<template>
  <span @click="$emit('click')">
    <slot name="icon">
      <i class="fallback-icon" :class="icon" :style="iconStyle"/>
    </slot>
  </span>
</template>

<script>
import Spacings from "../enums/Spacings";

export default {
  name: "Icon.vue",
  emits: ['click'],
  props: {
    size: {
      required: false,
      type: String,
      default: 'xxl',
      validator(value) {
        return Object.keys(Spacings).includes(value);
      }
    },
    icon: {
      type: String,
      required: false,
    }
  },
  computed: {
    iconStyle(){
      return  {
        padding: 0,
        width: Spacings[this.size] + 'px !important',
        height: Spacings[this.size] + 'px !important',
        minHeight: Spacings[this.size] + 'px !important',
        fontSize: ( Spacings[this.size] ) + 'px'
      };
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/_default.scss';
</style>
